import { IconName } from 'noddi-ui-common';
import { BOOKING_CATEGORY_ENUM } from 'noddi-util';

type Variant = {
  backgroundImage: string;
  iconName: IconName;
};

export const bookingCategoryVariants = (isMobile: boolean): Record<BOOKING_CATEGORY_ENUM, Variant> => ({
  [BOOKING_CATEGORY_ENUM.STONE_CHIP_REPAIR]: {
    backgroundImage: `/assets/svgs/booking/serviceCards/${isMobile ? 'mobile' : 'desktop'}/car_care.svg`,
    iconName: 'BrokenWindshield'
  },
  [BOOKING_CATEGORY_ENUM.WASHING_SERVICES]: {
    backgroundImage: `/assets/svgs/booking/serviceCards/${isMobile ? 'mobile' : 'desktop'}/washing_package.svg`,
    iconName: 'Drop'
  },
  [BOOKING_CATEGORY_ENUM.WHEEL_SERVICES]: {
    backgroundImage: `/assets/svgs/booking/serviceCards/${isMobile ? 'mobile' : 'desktop'}/wheel_service.svg`,
    iconName: 'WheelAngle'
  }
});
